import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import SurrogacyDetailPage from '@/pages/services/surrogacy';
import IVFDetailPage from '@/pages/services/ivf';
import FertilityDetailPage from '@/pages/services/egg-donation';
import CasesPage from '@/pages/cases/page';
import KnowledgePage from '@/pages/knowledge/page';
import KnowledgeDetailPage from '@/pages/knowledge/detail';
import ContactPage from '@/pages/contact/page';
import AdminEntry from '@/pages/admin/index';
import AdminDashboard from '@/pages/admin/page';
import CustomersPage from '@/pages/admin/customers/page';
import ArticlesAdminPage from '@/pages/admin/articles/page';
import ArticleEditor from '@/pages/admin/articles/editor';
import CasesAdminPage from '@/pages/admin/cases/page';
import FAQsAdminPage from '@/pages/admin/faqs/page';
import SettingsPage from '@/pages/admin/settings/page';
import TagsPage from '@/pages/knowledge/tags';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  // Flat service URLs (primary)
  {
    path: '/surrogacy',
    element: <SurrogacyDetailPage />,
  },
  {
    path: '/ivf',
    element: <IVFDetailPage />,
  },
  {
    path: '/fertility',
    element: <FertilityDetailPage />,
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  // Knowledge/News routes
  {
    path: '/news',
    element: <KnowledgePage />,
  },
  {
    path: '/news/:id',
    element: <KnowledgeDetailPage />,
  },
  // Tag routes
  {
    path: '/tags/:tag',
    element: <TagsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/admin',
    element: <AdminEntry />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'articles', element: <ArticlesAdminPage /> },
      { path: 'articles/new', element: <ArticleEditor /> },
      { path: 'articles/:id', element: <ArticleEditor /> },
      { path: 'cases', element: <CasesAdminPage /> },
      { path: 'faqs', element: <FAQsAdminPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;